import Vue from 'vue'
import i18n from './index'

const getTranslation = new Vue({
  i18n,
  methods: {
    getTranslation(key, params) {
      return this.$t(key, params)
    }
  }
}).getTranslation

export default getTranslation
